// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { func, string } from 'prop-types';

export const StyledIFrame = styled.iframe`
  position: fixed;
  top: 40px;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
`;

const StyledBackButton = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  max-width: auto;
  width: 100%;
  padding: 12px;
  z-index: 99999;
  display: block;
  color: #fff;
  background-color: gray;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  height: 40px;
  width: 100%;
  z-index: 999999;
  border: none;
  color: white;
  background: #505050;
`;

const IFrame = memo(({ source, onBackButtonClick }) => {
  const { t } = useTranslation();

  return (
    <div className="iframe">
      <StyledIFrame
        className="iframe"
        src={ source }
        id="iframe"
        title="iframe"
      />
      <StyledBackButton className="backButton" type="button" onClick={ onBackButtonClick }>
        { t('products.backToNOD') }
      </StyledBackButton>
    </div>
  );
});

IFrame.propTypes = {
  source: string,
  onBackButtonClick: func,
};

IFrame.displayName = 'IFrameComponent';

export default IFrame;
